import { createSelector } from '@ngrx/store';
import { DocumentTypes } from 'src/app/core/constants/pol.enums';
import { IMemberState } from '../../member.model';
import { selectMemberFeature } from '../../member.state';
import { IMemberDetailsState } from './member-details.model';

export const selectMemberDetails = createSelector(
  selectMemberFeature,
  (state: IMemberState) => state?.memberDetailsState
);

export const selectDelegatedAccessToken = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.delegatedAccessToken
);

export const selectSubscription = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.subscription?.subscriber
);

export const snapsRenewalDatesSelector = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.snapsRenewalDates
);

export const selectSubscriptionFamilies = createSelector(selectMemberDetails, (state: IMemberDetailsState) => ({
  families: state?.subscription?.families,
  isloading: state?.loading
}));

export const getSubscription = createSelector(selectMemberDetails, (state: IMemberDetailsState) => ({
  subscription: state?.subscription,
  loadingSubData: state?.loadingSubData,
  error: state?.getSubsError
}));

export const selectMemberPreferences = createSelector(selectMemberDetails, (state: IMemberDetailsState) => ({
  preferences: state?.subscription?.subscriber?.preferences,
}));

export const selectPCPHistory = createSelector(selectMemberDetails, (state: IMemberDetailsState) => state?.pcpHistory);

export const selectOtherCoverages = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.otherCoverages
);

export const selectCoverages = createSelector(selectMemberDetails, (state: IMemberDetailsState) => state?.coverages);

export const selectCoverageFilter = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.coverageFilter
);

export const selectSelectedCoverageItem = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.selectedCoverageItem
);

export const selectAssociatedFamily = createSelector(selectMemberDetails, (state: IMemberDetailsState) => ({
  associatedFamilies: state?.associatedFamilies,
  isloading: state?.loading
}));

export const selectDocuments = createSelector(selectMemberDetails, (state: IMemberDetailsState) => ({
  hasError: state?.documents?.error,
  isLoading: state?.documents?.loading,
  documents: state?.documents?.documents
}));

export const selectSpendingSummay = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.spendingSummary
);
export const selectSpendingAccounts = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.spendingAccounts
);

export const selectDisplayedCoverages = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.displayedCoverages
);

export const selectDisplayedOtherCoverages = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.displayedOtherCoverages
);

export const selectCareManagementDocuments = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.careManagementDocuments
);

export const selectMemberNetworks = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.memberNetworks
);

export const selectProviderDetails = createSelector(
  selectMemberDetails,
  (state: IMemberDetailsState) => state?.providerDetails
);
